import React from 'react';
import './confirmationView.css';
import Helmet from "react-helmet/es/Helmet";
import {DateTime} from 'luxon';
import NumberFormat from 'react-number-format';

class ConfirmationView extends React.Component {

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;
        this.onChangeView = this.props.onChangeView;
        this.makePaymentResponse = this.props.makePaymentResponse;

        this.state = {
        	showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            confirmView: {"bookingSummary":{
                "add-ons":[
                    
                    ],
                    "returnDate":"",
                    "charges":{
                       "insurance":{
                          "include":false
                       },
                       "paymentDueDate":"",
                       "balanceIncludeFuturePayments":0,
                       "balanceExcludeFuturePayments":0,
                       "scheduledPayment":0,
                       "paymentsToDate":0,
                       "lastScheduledPayment":"",
                       "remainingBalance":0,
                       "totalCost":"0"
                    }
                    
                    
                    
                 }
              },
            
        }

        window.dataLayer = window.dataLayer || [];
        try {
			var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/confirmation',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/confirmation',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else {
				console.log("off");    
			}
       
        } catch (error) {
            //swallow error
        }
    }
    checkNewPaymentWarning = () => {
    	if(this.state.newFuturePayments===true){
        	//this.setState({warningClass: 'warningMessageHeaderConfirmation'});
        }
    }
    
    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    getFormattedDate = (dateToFormat) => {
    	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
    	return formattedDate;
    }
    
    /* Spinner for Ajax calls */
    ajaxSpinnerShow = () => {
    	 document.getElementById("ajaxLoadText").innerHTML = "loading";
    	 document.getElementById("ajaxShim").style.display = "block";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
    	 document.getElementById("ajaxSpinner").style.display = "block";
     }	
     
     ajaxSpinnerHide = () => {
    	 document.getElementById("ajaxSpinner").style.display = "none";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
    	 document.getElementById("ajaxShim").style.display = "none";
     }
    
    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.getBookingAgain();
    }
   
    getBookingAgain = () => {
    	console.debug('getting booking...');
        let url = '/wthrest/customer-self-service/getBooking.rs';
        let payload = {
            "bookingNumber": localStorage.getItem("confirmationNumber"),
            "hash": this.props.hash
        }
        this.ajaxSpinnerShow();
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => { 
			//eslint-disable-next-line       	
        	if(jsonBookingResponse.futurePayments!==null&&jsonBookingResponse.futurePayments!=''){
        		for(let i = 0; i <jsonBookingResponse.futurePayments.length; i++) {
					//eslint-disable-next-line
        			if(jsonBookingResponse.futurePayments[i].newFuturePayment==true) {							
        				this.setState({newFuturePayments: true});
        		    
    				}
        		}

    			if(this.state.newFuturePayments===true){
    				this.props.CallTracker("Customer Self Service", "Page Alert", "Today's payment(or a portion of the payment) will be processed on the next business day, and is shown as a new scheduled payment.  Your Remaining Balance will be updated once your payment is processed.");
    			}
    		}
        	this.ajaxSpinnerHide();
        	document.getElementById("css_confContainer").style.display='block';
        	this.setState({confirmView: jsonBookingResponse});
        	return jsonBookingResponse;
        	
        }).catch(error => {
        	this.ajaxSpinnerHide();
        	console.log("get booking failed");
            //TODO set error
        	return null;
        });
    }
    
    render = () => {
        this.checkNewPaymentWarning();
        
        //const attributes = this.props.attributes;
        return (
        		
        	<div className="rea-appContainer" id="mainContent" tabindex="-1">

                <Helmet>
                    <title>Customer Self Service / Confirmation</title>
                </Helmet>
	            <div class="wth2-css_heading">
	        		<h1 class="wth2-pageTopH1" id="css_title_visible">Payment Confirmation</h1>
	            </div>
	            <div class="wth2-css_tripToolsHeading">
		        	<div id="css_tripTools">
		            	<a class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" href="# " id="css_tripTools_bookingSummary" onClick={e =>{e.preventDefault();this.props.onChangeView('summary-swap', this.booking, this.booking.hash, this.state.updatedBooking)} }>Return to Booking Summary</a>
		            </div>
	            </div>
	            <div class="wth2-cssMainContainer">
	        	
	        	<div id="paymentContents">
	        	{this.props.makePaymentResponse.paymentStatus===false &&
	        		<div id="message5" class="wth2-errorMessage wth2-errorMessageHeader">
			    		<i class="fa fa-exclamation-circle" aria-hidden="true"></i> We&#39;re Sorry. We are unable to process your payment. Please try your request again or call {this.props.siteConfigData.cruisePhone} and speak to a cruise expert who will be happy to assist you. Cruise experts are available {this.props.siteConfigData.operationHrs}.  
			    	</div>
	        	}
	        	{this.props.makePaymentResponse.paymentStatus===true &&
	        	<div id="message2" class="wth2-sucessMessage"><div class="wth2-sucessMessageCont" id="message2Cont"><span class=" wth2-sucessMessageHeader"><i class="fa fa-check-circle" aria-hidden="true"></i> Thank you for your payment of <NumberFormat value={this.props.makePaymentResponse.paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />.</span><br /> This payment will be credited to your account within one business day. Your updated summary of charges is listed below.</div></div>
	        	}
	        	{this.props.makePaymentResponse.paymentStatus===true &&	
	        		<div class="wth2-css_confContainer" id="css_confContainer" style={{ display: 'none' }}>
	        			<div class="wth_css_headContainer"><span id="css_confirmationSummary" class="wth2_css_headdesc">Summary of Charges</span></div>
	        			<div class="wth2_css_paymentInformationContainer">		
	        				<div><div class="wth2_css_confirmationLine wth2_css_headdesc" id="css_conf_totalLabel">Total:</div><div class="wth2_css_confirmationLine2" id="css_conf_total"><NumberFormat value={this.state.confirmView.bookingSummary.charges.totalCost} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div></div>
	        				<div><div class="wth2_css_confirmationLine wth2_css_headdesc" id="css_conf_travelProtLabel">Travel Insurance:</div><div class="wth2_css_confirmationLine2" id="css_conf_travelProt">
	        					{this.state.confirmView.bookingSummary.charges.insurance.include===false &&
	        					<span>Declined</span>
	        					}
	        					{this.state.confirmView.bookingSummary.charges.insurance.include===true &&
	        					<span>Included</span>
	        					}
	        				</div></div>
	        				<div><div class="wth2_css_confirmationLine wth2_css_headdesc" id="css_conf_paymentsAppliedLabel">Previous Payments:</div><div class="wth2_css_confirmationLine2" id="css_conf_paymentsApplied">-<NumberFormat value={localStorage.getItem('previousPayments')} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div></div>
	        				<div><div class="wth2_css_confirmationLine wth2_css_headdesc" id="css_conf_newPaymentLabel">Today&#39;sPayment:</div>
	        					<div className={`wth2_css_confirmationLine2 ${this.state.warningClass}`} id="css_conf_newPayment">-<NumberFormat value={this.props.makePaymentResponse.paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
	        						{this.state.newFuturePayments===true &&
	        						<span class="wth2-warningMessageHeaderConfirmation">*</span>
	        						}
	        					</div>
	        					{this.state.newFuturePayments===true &&
	        					<div class="wth2-warningMessageHeaderConfirmation wth2_css_confirmationLine3" id="css_conf_paymentPending">Payment pending - See Note Below</div>
	        					}
	        				</div>
	        				<div><div class="wth2_css_confirmationLine wth2_css_headdesc wth2-conf_remainingBalanceSeparator" id="css_remainingBalanceLabel">Remaining Balance:</div>
	        					{this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments > 0 &&
	        					<div class="wth2_css_confirmationLine2 wth2-conf_remainingBalanceSeparator" id="css_remainingBalance" ><NumberFormat value={this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
	        					}
	        					{this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments > 0 && this.state.confirmView.bookingOverview.cruise.cruiseLineName !== 'Viking River' && this.state.confirmView.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
	        					<div class="wth2_css_confirmationLine3 wth2-conf_remainingBalanceSeparator" id="css_dueDateConfirmation">due on {this.getFormattedDate(this.props.makePaymentResponse.paymentDueDate)}</div>
	        					}
	        					{this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments === 0.00 &&
	        					<div class="wth2_css_confirmationLine2" id="css_paidInFullConfirmation">Paid in Full</div>
	        					}
	        				</div>
	        				<div class="wth2_css_scheduledPaymentsContainer" id="css_scheduledPaymentsContainer">
	        					{//eslint-disable-next-line
								this.state.confirmView.futurePayments!=null&&this.state.confirmView.futurePayments!='' &&
	        					<div class="wth2_css_headdesc" id="css_scheduledPaymentsHeader">Scheduled Payments (<span id="css_scheduledPaymentsTotal"><NumberFormat value={this.state.confirmView.bookingSummary.charges.scheduledPayment} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> in total):</div>
	        					}
	        					{//eslint-disable-next-line
								this.state.confirmView.futurePayments!=null&&this.state.confirmView.futurePayments!='' &&
	        					this.state.confirmView.futurePayments.map((futurepayments, index, arr)=>(
		        					<div id={"css_futurePayment_" + index}>
		        						<span id={"css_futurePayment" + index + "_amount"}><NumberFormat value={futurepayments.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> on <span className="wth3-futurePayCCType" id={"css_futurePayment" + index + "_cctype"}>{futurepayments.creditCardType.replace("(R)", "\u00AE ").toLowerCase()}</span> ending in <span id={"css_futurePayment}" +index + "_ccnum"}>{futurepayments.maskedCreditCardNumber.slice(-4)}</span> on <span id={"css_futurePayment" + index + "_fpdate"}>{futurepayments.futurePaymentDate}</span>
		        					</div>
	        					))}
	        					{localStorage.getItem("scheduledPaymentHasChanged")==='true' &&
	        					<div>
	        						<div id="scheduledPaymentWiseMessageWraper" class="scheduledPaymentWiseMessageWraper wth2-warningMessage" aria-hidden="true">
	        							<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
	        							<div id="scheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
	        							<div id="scheduledPaymentWiseMessageText">Today&#39;s payment reduced the amount of a previously scheduled payment. Your current scheduled payments (if any) are reflected in the Summary of Charges above.</div>		
	        						</div>						
	        					</div>
	        					}
	        					{this.state.newFuturePayments===true &&
	        					<div>
	        						<div id="newScheduledPaymentWiseMessageWraper" class="newScheduledPaymentWiseMessageWraper wth2-warningMessage" aria-hidden="true">
	        							<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
	        							<div id="newScheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
	        							<div id="newScheduledPaymentWiseMessageText">Today&#39;s payment(or a portion of the payment) will be processed on the next business day, and is shown as a new scheduled payment.  Your Remaining Balance will be updated once your payment is processed.</div>		
	        						</div>						
	        					</div>
	        					}
	        				</div>
	        			</div>
	        		</div>
	        		}
	        	</div>
	        	
	        </div>
            </div>
	            
        );
    }

   
}

export default ConfirmationView;
